import { jsx as h } from "react/jsx-runtime";
import { SvgIcon as r } from "../SvgIcon.js";
const m = (o) => /* @__PURE__ */ h(r, { ...o, children: /* @__PURE__ */ h("path", { d: "M8.33831 17.5041v-1.6676H5.33445L15.8369 5.33406v3.00386h1.6676V2.49585h-5.8421v1.66759h3.0039L4.16383 14.6659v-3.0038h-1.6676v5.842h5.84208Z" }) });
export {
  m as Enlarge
};
//# sourceMappingURL=Enlarge.js.map
